<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.31375 3.94113C7.90191 1.35296 12.0982 1.35296 14.6863 3.94113C17.2745 6.52929 17.2745 10.7255 14.6863 13.3137L10.8082 17.1919C10.3618 17.6382 9.63823 17.6382 9.19192 17.1919L5.31375 13.3137C2.72558 10.7255 2.72558 6.52929 5.31375 3.94113ZM10 10.521C11.0458 10.521 11.8936 9.67319 11.8936 8.62742C11.8936 7.58164 11.0458 6.73387 10 6.73387C8.95426 6.73387 8.10649 7.58164 8.10649 8.62742C8.10649 9.67319 8.95426 10.521 10 10.521Z"
            fill="#8490A1"
        />
    </svg>
</template>
